@if (mounted()) {
<div class="mm-scrim" (click)="requestClose()"></div>

<div
  class="mm-shell"
  role="region"
  aria-label="Services"
  (mouseenter)="hoverIn.emit()"
  (mouseleave)="hoverOut.emit()"
>
  <span class="mm-glow" aria-hidden="true"></span>

  <div class="mm-panel">
    <span class="mm-surface" aria-hidden="true"></span>

    <!-- ambient background: blobs, dot grid, hairlines, dust -->
    <div class="mm-bg" aria-hidden="true">
      <span class="mm-blob mm-blob--pink"></span>
      <span class="mm-blob mm-blob--violet"></span>
      <span class="mm-blob mm-blob--blue"></span>
      <span class="mm-dots"></span>
      <svg class="mm-lines" viewBox="0 0 1280 580" preserveAspectRatio="none">
        <path class="mm-line" d="M-40 130 C 240 60, 520 210, 840 120 S 1180 40, 1330 150" />
        <path class="mm-line" d="M-40 330 C 300 250, 560 420, 900 320 S 1200 250, 1330 340" />
        <path class="mm-line" d="M-40 500 C 260 440, 600 560, 960 470 S 1220 420, 1330 500" />
      </svg>
      <span class="mm-particles">
        @for (p of particles; track $index) {
        <i
          class="mm-particle"
          [style.left.%]="p.x"
          [style.top.%]="p.y"
          [style.width.px]="p.s"
          [style.height.px]="p.s"
        ></i>
        }
      </span>
    </div>

    <div class="mm-body">
      <!-- ── left promotional panel ─────────────────────────────────── -->
      <aside class="mm-promo">
        <span class="mm-badge">OUR SERVICES</span>

        <h2 class="mm-promo-title">
          Complete Digital Solutions<br />
          For <span class="mm-grad">Modern Businesses</span>
        </h2>

        <span class="mm-rule"></span>

        <p class="mm-promo-copy">
          Strategy, design and engineering under one roof — built to help ambitious
          teams launch faster and scale further.
        </p>

        <div class="mm-ill">
          <span class="mm-ill-layer mm-ill-halo" data-depth="6"></span>

          <span class="mm-ill-layer mm-ill-main" data-depth="14">
            <span class="mm-ill-tilt">
              <svg viewBox="0 0 300 200" fill="none" aria-hidden="true">
                <defs>
                  <linearGradient id="mmScreen" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stop-color="#ffffff" />
                    <stop offset="1" stop-color="#f3edff" />
                  </linearGradient>
                  <linearGradient id="mmBrand" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0" stop-color="#FF3EA5" />
                    <stop offset="0.55" stop-color="#8B5CF6" />
                    <stop offset="1" stop-color="#4F7CFF" />
                  </linearGradient>
                  <linearGradient id="mmArea" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stop-color="#8B5CF6" stop-opacity="0.34" />
                    <stop offset="1" stop-color="#8B5CF6" stop-opacity="0" />
                  </linearGradient>
                </defs>

                <rect
                  x="16"
                  y="14"
                  width="268"
                  height="168"
                  rx="16"
                  fill="url(#mmScreen)"
                  stroke="#EDE6FB"
                  stroke-width="1.2"
                />

                <!-- chrome -->
                <circle cx="34" cy="32" r="3.2" fill="#FF3EA5" opacity=".55" />
                <circle cx="45" cy="32" r="3.2" fill="#8B5CF6" opacity=".45" />
                <circle cx="56" cy="32" r="3.2" fill="#4F7CFF" opacity=".45" />
                <rect x="196" y="26" width="72" height="12" rx="6" fill="#F1ECFE" />

                <!-- kpi row -->
                <rect x="32" y="50" width="72" height="34" rx="9" fill="#FFF" stroke="#F0EAFD" />
                <rect x="40" y="58" width="30" height="4" rx="2" fill="#E4DBFA" />
                <rect x="40" y="67" width="46" height="8" rx="4" fill="url(#mmBrand)" opacity=".85" />

                <rect x="112" y="50" width="72" height="34" rx="9" fill="#FFF" stroke="#F0EAFD" />
                <rect x="120" y="58" width="24" height="4" rx="2" fill="#E4DBFA" />
                <rect x="120" y="67" width="36" height="8" rx="4" fill="#4F7CFF" opacity=".7" />

                <rect x="192" y="50" width="72" height="34" rx="9" fill="#FFF" stroke="#F0EAFD" />
                <rect x="200" y="58" width="28" height="4" rx="2" fill="#E4DBFA" />
                <rect x="200" y="67" width="42" height="8" rx="4" fill="#FF3EA5" opacity=".62" />

                <!-- area chart -->
                <rect x="32" y="94" width="152" height="72" rx="11" fill="#FFF" stroke="#F0EAFD" />
                <path
                  d="M44 148 L70 132 L94 140 L118 116 L146 124 L172 104 L172 156 L44 156 Z"
                  fill="url(#mmArea)"
                />
                <path
                  d="M44 148 L70 132 L94 140 L118 116 L146 124 L172 104"
                  stroke="url(#mmBrand)"
                  stroke-width="2.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <circle cx="172" cy="104" r="3.6" fill="#fff" stroke="#4F7CFF" stroke-width="2.2" />

                <!-- bar chart -->
                <rect x="192" y="94" width="72" height="72" rx="11" fill="#FFF" stroke="#F0EAFD" />
                <rect x="202" y="136" width="9" height="20" rx="4.5" fill="#FFD3E9" />
                <rect x="216" y="124" width="9" height="32" rx="4.5" fill="#FF3EA5" opacity=".62" />
                <rect x="230" y="112" width="9" height="44" rx="4.5" fill="#8B5CF6" opacity=".68" />
                <rect x="244" y="102" width="9" height="54" rx="4.5" fill="url(#mmBrand)" />
              </svg>
            </span>
          </span>

          <span class="mm-ill-layer mm-ill-chip mm-ill-chip--a" data-depth="20">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M11.4 3 13.1 8.1 18.2 9.8 13.1 11.5 11.4 16.6 9.7 11.5 4.6 9.8 9.7 8.1Z" />
            </svg>
            <b>+38%</b>
            <em>growth</em>
          </span>

          <span class="mm-ill-layer mm-ill-chip mm-ill-chip--b" data-depth="24">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="m4.5 12.5 5 5 9.5-11" />
            </svg>
            <b>Live</b>
            <em>deploys</em>
          </span>
        </div>

        <span class="mm-pop mm-promo-cta">
          <a class="mm-btn" routerLink="/contact-us" (click)="requestClose()">
            Request Consultation
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M5 12h13M13 6l6 6-6 6" />
            </svg>
          </a>
        </span>
      </aside>

      <!-- ── service columns ────────────────────────────────────────── -->
      <div class="mm-cols">
        @for (col of columns; track col.title) {
        <section class="mm-col" [attr.data-accent]="col.accent">
          <header class="mm-col-head">
            <span class="mm-col-icon">
              <ng-container
                *ngTemplateOutlet="glyph; context: { $implicit: col.icon }"
              ></ng-container>
            </span>
            <h3>{{ col.title }}</h3>
          </header>

          <ul class="mm-list">
            @for (item of col.items; track item.title) {
            <li class="mm-reveal">
              <a class="mm-item" [routerLink]="item.link" (click)="requestClose()">
                <span class="mm-item-icon">
                  <ng-container
                    *ngTemplateOutlet="glyph; context: { $implicit: item.icon }"
                  ></ng-container>
                </span>
                <span class="mm-item-text">
                  <span class="mm-item-title">{{ item.title }}</span>
                  <span class="mm-item-desc">{{ item.desc }}</span>
                </span>
                <svg class="mm-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="m9 5 7 7-7 7" />
                </svg>
              </a>
            </li>
            }
          </ul>
        </section>
        }
      </div>
    </div>

    <!-- ── bottom CTA strip ─────────────────────────────────────────── -->
    <div class="mm-cta">
      <span class="mm-cta-mark" aria-hidden="true">🚀</span>
      <div class="mm-cta-copy">
        <strong>Ready to build your next project?</strong>
        <span>Let's create something extraordinary together.</span>
      </div>
      <span class="mm-pop">
        <a class="mm-btn mm-btn--lg" routerLink="/contact-us" (click)="requestClose()">
          Get Free Consultation
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M5 12h13M13 6l6 6-6 6" />
          </svg>
        </a>
      </span>
    </div>
  </div>
</div>
}

<!-- one generic renderer for every glyph in the menu -->
<ng-template #glyph let-icon>
  <svg
    class="mm-glyph mm-glyph-pop"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    @for (d of icon.p; track $index) {
    <path [attr.d]="d" />
    } @for (c of icon.c; track $index) {
    <circle [attr.cx]="c[0]" [attr.cy]="c[1]" [attr.r]="c[2]" />
    } @for (e of icon.e; track $index) {
    <ellipse
      [attr.cx]="e[0]"
      [attr.cy]="e[1]"
      [attr.rx]="e[2]"
      [attr.ry]="e[3]"
      [attr.transform]="'rotate(' + e[4] + ' ' + e[0] + ' ' + e[1] + ')'"
    />
    }
  </svg>
</ng-template>
